import React, {useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {confirm} from 'react-confirm-box'
import {assignetagsContacts, CreateData, getalltagsdata} from '../../Tags/TagSlice/TagsSlices'
import {KTSVG} from '../../../../../../_metronic/helpers'
import TagPopupModal from './TagPopupModal'
import Select, {components, MenuListProps} from 'react-select'
import {
  useFetchTagQuery,
  useUpdateContactTagsMutation,
} from '../../../../../../services/cellcast.v3'
import {getIsDefaultRegion} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const optionsWithLabelChange = {
  closeOnOverlayClick: false,
  labels: {
    confirmable: 'Confirm',
    cancellable: 'Cancel',
  },
}

const AssignedTags = ({show, handleClose, checkList, callbackFn}: any) => {
  const dispatch = useDispatch()
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)
  const subscriberList = useSelector(
    (state: any) => state?.subscriberData?.subscriberList?.data?.items
  )
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)

  const data123 = useSelector((state: any) => state?.subscriberData?.Report?.data)

  const [tag, setTag] = useState<any>([])
  const [openTagPopup, setOpenTagPopup] = useState(false)
  const [selectedTag, setSelectedTag] = useState<any>([])

  const {tagRegion} = useFetchTagQuery(
    {type: 'tag', limit: 1000},
    {
      selectFromResult: ({data}) => {
        return {
          tagRegion: data
            ? data?.data?.items
                ?.filter((val: any) => val.type !== 'list' && val?.isHidden === false)
                .map((val: any) => ({value: val?._id, label: val?.name}))
            : [],
        }
      },
      skip: isDefaultRegion,
    }
  )

  const [updateTagRegion] = useUpdateContactTagsMutation()

  useEffect(() => {
    dispatch(getalltagsdata())
  }, [])

  useEffect(() => {
    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.isHidden === false && val?.type !== 'list'
      }
      return val?.isHidden === false
    })
    let listData = filteredTags?.map((val: any) => ({value: val?._id, label: val?.name}))

    setTag(listData)
  }, [tagslist])

  const handleCreate = async (e: any) => {
    // if(/^[a-zA-Z0-9_]{2,25}+$/gm.test(e)){
    let confirNew = await confirm(
      'Are you sure you want to create a new tag?',
      optionsWithLabelChange
    )
    setSelectedTag([...selectedTag, {value: e, label: e}])
    confirNew &&
      dispatch(
        CreateData({
          name: e,
        })
      )
    // }
  }

  const handleChange = async (e: any) => {
    setSelectedTag(e)
  }

  const handleSubmmit = async () => {
    if (selectedTag?.length > 0) {
      const tagIds = selectedTag?.map((it: any) => it?.value)

      if (isDefaultRegion) {
        dispatch(
          assignetagsContacts({
            data: {contactIds: checkList, tagId: tagIds},
            id: {id: groupid},
            callbackFn: callbackFn,
          })
        )
      } else {
        await updateTagRegion({
          ids: checkList,
          mode: 'add',
          tagIDs: tagIds,
        })
      }
      setSelectedTag([])
      handleClose()
    }
  }

  const MenuList = (props: MenuListProps<any>) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: '6px',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            borderTop: '1px solid #F4F5F7',
            paddingTop: '10px',
          }}
          onClick={() => {
            setOpenTagPopup(true)
          }}
        >
          <i
            style={{
              color: '#7950F2',
              fontWeight: 'bold !important',
            }}
            className='bi bi-plus-lg'
          ></i>
          <p
            style={{
              color: '#7950F2',
              margin: 0,
              fontWeight: 600,
            }}
          >
            Create new
          </p>
        </div>
      </components.MenuList>
    )
  }

  const AddTagPopup = useMemo(
    () => (
      <TagPopupModal
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
        show={openTagPopup}
        handleClose={() => {
          // const newArr = [...selectedTag].filter((key) => key?.value !== '')

          setOpenTagPopup(false)
          // setSelectedTag(newArr)
        }}
      />
    ),
    [openTagPopup]
  )

  return (
    <>
      {AddTagPopup}
      <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered mw-450px'>
        <div className='modal-header'>
          <h2>Tag contact</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
          </div>
        </div>
        <div className='modal-body'>
          <label className='col-form-label fw-bold fs-6'>Tag name</label>
          <Select
            value={selectedTag}
            components={{MenuList}}
            isMulti
            className='react-tags-selectbox'
            options={isDefaultRegion ? tag : tagRegion}
            onChange={handleChange}
          />
        </div>
        <div className='modal-footer d-flex justify-content-end m-0'>
          <button
            onClick={() => {
              handleClose()
              setSelectedTag([])
            }}
            type='button'
            className='btn btn-light-primary'
          >
            Cancel
          </button>
          <button onClick={handleSubmmit} id='submit' type='button' className='btn btn-primary'>
            Submit
          </button>
        </div>
      </Modal>
    </>
  )
}

export default AssignedTags
